import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ValidatorService} from '../recursos/servicios/validator.service';
import {StockValidatorService} from '../recursos/servicios/StockValidatorService';
import {ConsumerService} from '../../../../recursos/servicio/consumer.service';
import {StockProducts} from '../recursos/modelo/stockProducts';
import {Emisor} from '../recursos/modelo/emisor';
import {WebServices} from '../../../../recursos/modelo/consumerModel/web-services.enum';
import {UtilConfig} from '../../../../../autenticacion/servicios/UtilConfig';
import {Usuario} from '../../usuario/recursos/modelo/usuario';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';

declare const $: any;
declare var swal: any;


interface FileReaderEventTarget extends EventTarget {
    result: string;
}

interface FileReaderEvent extends Event {
    target: FileReaderEventTarget;

    getMessage(): string;
}

@Component({
    selector: 'cmp-stock-products',
    templateUrl: './view/cmp-conf-stock-productos.component.html',
    styleUrls: ['./css/cmp-conf-stock-productos.component.scss'],
    providers: [
        {provide: ValidatorService, useClass: StockValidatorService}
    ],
})
export class CmpStockProductsComponent implements OnInit, AfterViewInit {

    settings: any;

    unitsList: any[] = [];

    afectacionList = [];


    @Input() emisor: Emisor;

    @Output() stockListChange = new EventEmitter<StockProducts[]>();


    archivoExcel = '';
    popupProducto = false;
    productoModificar: StockProducts = new StockProducts();
    rutaFormato = '';

    cargaMasivaActiva = false;
    usuariosession: Usuario;

    displayedColumns = ['productCode', 'description', 'afectacionIgv', 'measurementUnit', 'valor', 'actionsColumn'];
    dataSource = new MatTableDataSource<StockProducts>();

    @ViewChild(MatPaginator) paginator: MatPaginator;


    /**
     * Set the paginator after the view init since this component will
     * be able to query its view for the initialized paginator.
     */
    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
    }

    applyFilter(filterValue: any) {
        filterValue = filterValue.value.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }

    constructor(private stockValidator: ValidatorService,
                private util: UtilConfig,
                private consumerService: ConsumerService
    ) {
        this.rutaFormato = this.util.URL_WS_BACKEND + '/Productos.xlsx';
        this.usuariosession = this.util.getCurrentUser();

    }

    ngOnInit() {
        if (!this.emisor) {
            this.emisor = new Emisor();
        }

        this.afectacionList.push({value: 'GRAVADO', title: 'GRAVADO'});
        this.afectacionList.push({code: 'INAFECTO', value: 'INAFECTO'});
        this.afectacionList.push({code: 'EXONERADO', value: 'EXONERADO'});
        this.getUnit();
        this.emisor.productsStockList.forEach(element => {
            element.mUnits = element.measurementUnit.label;
        });

        this.dataSource.data = this.emisor.productsStockList;
    }

    getUnit() {
        this.cargaMasivaActiva = true;
        this.consumerService.update(WebServices.URL_GET_UNITS).subscribe(result => {
            $.each(result['units'], (pos, item) => {
                this.unitsList.push({value: item.code, title: item.label});
            });
            localStorage.setItem('units', JSON.stringify(result['units']));
            this.cargaMasivaActiva = false;
        }, err => {
            this.cargaMasivaActiva = false;
            swal({
                title: 'Error',
                text: err,
                type: 'error',
                showCancelButton: false,
                confirmButtonText: 'Proceder!'
            });

        });
    }

    subirArchivo($event) {
        const input = $event.currentTarget;

        if (input.files && input.files[0]) {
            const reader = new FileReader();
            reader.onload = (e: FileReaderEvent) => {
                this.archivoExcel = e.target.result.split('base64,')[1];

                const param: any = {};
                param.massiveLoadFile = this.archivoExcel;
                this.cargaMasivaActiva = true;
                this.consumerService.post<any>(WebServices.URL_CARGA_MASIVA_PRODUCTOS, param)
                    .subscribe(result => {
                        if (result['codigo'] === 1 && result['mensaje'] === 'OK') {

                            const productsStock = result['productsStock'];
                            $.each(productsStock, (pos, item) => {
                                item.mUnits = item.measurementUnit.label;
                                this.emisor.productsStockList.push(item);
                            });
                            input.files = null;
                            $('#wizard-productos').val('');
                        } else {
                            swal({
                                title: 'Los siguientes productos no se pudieron crear:',
                                text: result['mensaje'],
                                type: 'warning',
                                showCancelButton: false,
                                confirmButtonColor: '#3085d6',
                                confirmButtonText: 'ok'
                            });
                            input.files = null;
                            $('#wizard-productos').val('');
                        }
                        this.cargaMasivaActiva = false;
                    }, err => {
                        this.cargaMasivaActiva = false;
                    });


            };
            reader.readAsDataURL(input.files[0]);
        }
    }

    onChangeConfirm(event) {
        let index = -1;
        let pos = 0;
        this.emisor.productsStockList.forEach((item) => {
            if (item.productCode === event.productCode) {
                index = pos;
            }
            pos++;
        });
        if (index > -1) {
            this.emisor.productsStockList[index] = event;
            this.dataSource.data = this.emisor.productsStockList;
        }
    }

    onDeleteConfirm(event) {
        let index = -1;
        let pos = 0;
        this.emisor.productsStockList.forEach((item) => {
            if (item.productCode === event.productCode) {
                index = pos;
            }
            pos++;
        });
        if (index > -1) {
            this.emisor.productsStockList.splice(index, 1);
            this.dataSource.data = this.emisor.productsStockList;
        }
    }


    modificarProduct(element) {
        this.productoModificar = element;
        this.openPopupProducto();
    }


    openPopupProducto() {
        this.popupProducto = true;
    }

    cerrarPopupProducto() {
        this.productoModificar = new StockProducts();
        this.popupProducto = false;
    }

    handlerAgregarItemLista(event) {
        this.cerrarPopupProducto();
        event.mUnits = event.measurementUnit.label;
        if (!event.id) {
            this.emisor.productsStockList.push(event);
            this.dataSource.data = this.emisor.productsStockList;
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/cmp-conf-stock-productos/cmp-conf-stock-productos.component.ts